import React from 'react';

import { PageTitle } from '../../../components';
import { ScheduleList } from '../../../sections';



const ScheduleListPage = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'Schedule List'} page={'Schedule List'} />

      {/* Schedule list section */}
      <ScheduleList />

    </>
  );
};

export default ScheduleListPage;